// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class ErrorEnvelope implements flatbuffers.IUnpackableObject<ErrorEnvelopeT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ErrorEnvelope {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsErrorEnvelope(bb:flatbuffers.ByteBuffer, obj?:ErrorEnvelope):ErrorEnvelope {
  return (obj || new ErrorEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsErrorEnvelope(bb:flatbuffers.ByteBuffer, obj?:ErrorEnvelope):ErrorEnvelope {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ErrorEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

code():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

name():string|null
name(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
name(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

message():string|null
message(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
message(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startErrorEnvelope(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addCode(builder:flatbuffers.Builder, code:number) {
  builder.addFieldInt32(0, code, 0);
}

static addName(builder:flatbuffers.Builder, nameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, nameOffset, 0);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, messageOffset, 0);
}

static endErrorEnvelope(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createErrorEnvelope(builder:flatbuffers.Builder, code:number, nameOffset:flatbuffers.Offset, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  ErrorEnvelope.startErrorEnvelope(builder);
  ErrorEnvelope.addCode(builder, code);
  ErrorEnvelope.addName(builder, nameOffset);
  ErrorEnvelope.addMessage(builder, messageOffset);
  return ErrorEnvelope.endErrorEnvelope(builder);
}

unpack(): ErrorEnvelopeT {
  return new ErrorEnvelopeT(
    this.code(),
    this.name(),
    this.message()
  );
}


unpackTo(_o: ErrorEnvelopeT): void {
  _o.code = this.code();
  _o.name = this.name();
  _o.message = this.message();
}
}

export class ErrorEnvelopeT implements flatbuffers.IGeneratedObject {
constructor(
  public code: number = 0,
  public name: string|Uint8Array|null = null,
  public message: string|Uint8Array|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const name = (this.name !== null ? builder.createString(this.name!) : 0);
  const message = (this.message !== null ? builder.createString(this.message!) : 0);

  return ErrorEnvelope.createErrorEnvelope(builder,
    this.code,
    name,
    message
  );
}
}
